import { Component, OnDestroy, OnInit } from '@angular/core';
import { transition, trigger, useAnimation } from '@angular/animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Email } from './../../../../assets/smtp.js';
import { fadeInLeft, fadeInRight } from 'ng-animate';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'leave-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss'],
  animations: [
    trigger('fadeInLeft', [transition('* => *', useAnimation(fadeInLeft, {
      // Set the duration to 5seconds and delay to 0seconds
      params: { timing: 4, delay: 0 }
    }))]),
    trigger('fadeInRight', [transition('* => *', useAnimation(fadeInRight, {
      // Set the duration to 5seconds and delay to 0seconds
      params: { timing: 4, delay: 0 }
    }))])
  ]
})
export class LeaveRequestComponent implements OnInit, OnDestroy {

  fadeInLeft: any;
  fadeInRight: any;

  firstFormGroup: FormGroup;

  subscribion: Subscription;

  auditText1:string;
  auditText2:string;
  nameFirstStep1: string;
  nameFirstStep2: string;

  auditText: string;
  nameFirstStep: string;
  turnAnimation = false;

  constructor(private modalService: NgbModal, private _formBuilder: FormBuilder, private translate: TranslateService) { }

  ngOnInit() {
    this.readTranslateData();

    this.firstFormGroup = this._formBuilder.group({
      nameCtrl: ['', [Validators.required]],
      companyCtrl: ['', [Validators.required]],
      phoneCtrl: ['', [Validators.required, Validators.pattern("(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})")]],
      emailCtrl: ['', [Validators.required, Validators.email]],
      skypeCtrl: '',
      aboutCtrl: ['', [Validators.maxLength(500)]]
    });
  }

  readTranslateData(){
    this.subscribion = this.translate.stream('REQUEST.TS').subscribe((res) => {
      this.auditText1 = res['auditText1'];
      this.auditText2 = res['auditText2'];
      this.nameFirstStep1 = res['nameFirstStep1'];
      this.nameFirstStep2 = res['nameFirstStep2'];
    });
    this.auditText = this.auditText1;
    this.nameFirstStep = this.nameFirstStep1;
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true, windowClass: "MoveOn", backdrop: 'static' });
    document.body.style.paddingRight = "0px";

    setTimeout(() => {
      let headerSteps = document.getElementsByClassName('mat-step-header');
      for (let index = 0; index < headerSteps.length; index++) {
        let element = headerSteps[index] as HTMLElement;
        element.style.pointerEvents = "none";
      }
    }, 555);
  }

  fixLastStepIcon() {
    setTimeout(() => {
      let editElement = document.getElementsByClassName('mat-step-icon-state-edit')[0] as HTMLElement;
      let doneElement = document.getElementsByClassName('mat-step-icon-state-done')[0] as HTMLElement;
      let doneElementPaste = document.getElementsByClassName('mat-step-icon-state-number')[0] as HTMLElement;

      let clone;
      if (editElement !== undefined) {
        clone = editElement.cloneNode(true);
      } else if (doneElement !== undefined) {
        clone = doneElement.cloneNode(true);
      }

      doneElementPaste.replaceWith(clone);
    }, 500);
  }

  sendRequest(stepper: MatStepper) {
    this.nameFirstStep = this.nameFirstStep2 + this.firstFormGroup.controls["nameCtrl"].value;
    setTimeout(() => {
      this.turnAnimation = true;
    }, 800);
    setTimeout(() => {
      stepper.next();
      this.onSubmit();
      this.auditText = this.auditText2;
    }, 100);
  }

  onSubmit() {
    this.fixLastStepIcon();

    let body = `
        <b>About Customer</b><br/><br/>
        <b>Name: </b>${this.firstFormGroup.controls["nameCtrl"].value}<br/> 
        <b>Name company: </b>${this.firstFormGroup.controls["companyCtrl"].value}<br/> 
        <b>Email: </b>${this.firstFormGroup.controls["emailCtrl"].value}<br/> 
        <b>Phone number: </b>${this.firstFormGroup.controls["phoneCtrl"].value}<br/> 
        <b>Skype: </b>${this.firstFormGroup.controls["skypeCtrl"].value}<br/>
        <b>Additional information: </b>${this.firstFormGroup.controls["aboutCtrl"].value}<br/> 
        <br/>`;

    body += `<b>~End of Message.~</b>`;

    Email.send({
      Host: 'smtp.elasticemail.com',
      Username: 'owner@customsolutions.info',
      Password: '3E829C5D585B36117614FD683054A24B3FC5',
      To: ['sales@customsolutions.info', 'vitaliikyrylov@customsolutions.info'],
      From: 'owner@customsolutions.info',
      Subject: 'Audit Potential Customer',
      Body: body
    }).then(message => {
      let answerFromSmtp = message as string;
      if (answerFromSmtp.toLocaleLowerCase() != 'ok') {
        console.error(answerFromSmtp);
      }
    });
  }

  closeModalWindow(stepper: MatStepper) {
    this.modalService.dismissAll();
    stepper.reset();

    this.turnAnimation = false;
    this.auditText = this.auditText1;
    this.nameFirstStep = this.nameFirstStep1;
  }

  ngOnDestroy(): void {
    this.subscribion.unsubscribe();
  }
}
